// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const NetworkIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="NetworkIcon" ref={forwardedRef} {...props}>
      <path d="M7 3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1.361v1.435h5.064V12H16.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1.953v-1.315H5.547V12H7.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.797V9.435H9.39V8H8a1 1 0 0 1-1-1zm1.5 3.5h3v-3h-3zM4 16.5h3v-3H4zm9-3v3h3v-3z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const NetworkIcon = /* @__PURE__ */ Object.assign(NetworkIconComponent, {
  displayName: 'NetworkIcon',
});
